import { LoadableLazy } from '@confluence/loadable';

export const AgentMentionFyiNudgeAsync = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-AgentMentionFyiNudge" */ '../src/AgentMentionFyiNudge.tsx'
			)
		).AgentMentionFyiNudge,
});
